import React, { Component } from 'react';
import { Link, Redirect, withRouter  } from 'react-router-dom';
import { withFormik } from 'formik';
import { connect }  from 'react-redux';
import * as yup from 'yup'

import { addClassToBody }  from '../../utils/utils';
import { getAuthToken }  from '../../store/actions';
import InputField from '../UI/InputField';
import CheckboxField from '../UI/CheckboxField';
import illustration from '../../assets/img/illustration.svg';


class Login extends Component {
    render() {
        const { values, handleChange, setFieldValue, handleBlur, handleSubmit, errors, touched, isAuthenticated, authRedirectPath } = this.props;
        addClassToBody();
        return (
            <div className="sign-form flex">
                { isAuthenticated &&  <Redirect to={ authRedirectPath } /> }
                <div className="illustration flex align-center">
                    <img src={ illustration } alt="right illustration"/>
                </div>
                <div className="form">
                    <div className="form-title flex align-center justify-center">
                        <h1 className="uppercase">log in</h1>
                    </div>

                    <form id="form5" onSubmit={ handleSubmit }>
                        <div className="inner">

                            <InputField type="text"
                                        error={ touched.username && errors.username }
                                        floatingLabelText="Username"
                                        name="username"
                                        value={ values.username }
                                        onChange={ handleChange }
                                        onBlur={ handleBlur } />

                            <InputField type="password"
                                        error={ touched.password && errors.password }
                                        floatingLabelText="Password"
                                        name="password"
                                        value={ values.password }
                                        onChange={handleChange}
                                        onBlur={ handleBlur } />

                            <div className="flex align-center justify-between mt-30">
                                <div className="checkbox full-width">
                                    <CheckboxField label="Remember Me"
                                                   name="remember"
                                                   value={ values.remember }
                                                   onChange={setFieldValue} />

                                </div>
                                {/*<div className="full-width text-right">*/}
                                    {/*<Link className="underline color-primary w-800" to="/forgot">Forgot Password</Link>*/}
                                {/*</div>*/}
                            </div>

                            <div className="text-center mt-90">
                                <button type="submit" className="btn filled primary min-220">Login</button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        );
    }

}


const mapDispatchToProps = dispatch => {
    return {
        getAuthToken: credentials => dispatch( getAuthToken(credentials) )
    };
};

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath,
        error: state.auth.error
    };
};

const LoginWithFormik = withFormik({
    mapPropsToValues({ username, password, remember }) {
        return {
            username: username || localStorage.getItem('foodna-portal-c-username') || '',
            password: password || localStorage.getItem('foodna-portal-c-password') || '',
            remember: remember || false
        };
    },
    validationSchema: yup.object().shape({
        username: yup.string().required('This field is mandatory.'),
        password: yup.string().min(6, 'The number of characters should be at least 6.').required('This field is mandatory.'),
    }),
    handleSubmit(values, { props }) {
        if (values.remember) {
            localStorage.setItem('foodna-portal-c-username', values.username);
            localStorage.setItem('foodna-portal-c-password', values.password);
        } else {
            localStorage.removeItem('foodna-portal-c-username');
            localStorage.removeItem('foodna-portal-c-password');
        }
        values.remember = true;
        props.getAuthToken(values);
    }
})( Login );

export default withRouter( connect(mapStateToProps, mapDispatchToProps)( LoginWithFormik ) );



// WEBPACK FOOTER //
// ./src/components/Login/Login.js